/**
 * TrueConditionType - Condition toujours vraie
 * Identique à Flutter TrueConditionType
 */

import {ConditionType} from '../../types/ConditionType';
import {GameState} from '../../../models/GameState';

export class TrueConditionType implements ConditionType {
  typeName: string = 'TRUE';
  messageKey?: string = 'laventurier.condition.true.name';
  descriptionKey?: string = 'laventurier.condition.true.desc';
  errorKey?: string = 'laventurier.condition.true.error';
  hasValue: boolean = false;
  hasAttribute: boolean = false;
  attribute?: string;

  constructor(attribute?: string) {
    this.attribute = attribute;
  }

  evaluate(gameState: GameState, condition: any): boolean {
    // Condition toujours vraie
    return true;
  }
}
